import GoogleTagManager from 'iovisit-ferraraterraeacqua/components/GoogleTagManager/GoogleTagManager';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import React from 'react';
import { connect } from 'react-redux';
import { MetaPixelsEmbedder } from '../MetaPixelEmbedder/MetaPixelEmbedder';

const GlobalAppExtras = ({ pathname, userid }) => {
  return (
    <>
      <Helmet titleTemplate={`%s - Ferrara Terra e Acqua`} />
      <Helmet>
        <meta property="og:type" content="website"></meta>
      </Helmet>
      <GoogleTagManager />
      <MetaPixelsEmbedder />
    </>
  );
};

export default connect(
  (state, props) => ({
    pathname: props.location?.pathname,
    userid: props.userId,
  }),
  {},
)(GlobalAppExtras);
